import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API, APP_NAME } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const logoUrl = "https://yourpersonalshopper-storage.sfo3.digitaloceanspaces.com/assets/bo_logo.webp";
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    // Update page title
    useEffect(() => {
        document.title = `Forgot Password - ${APP_NAME}`;
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await axios.post(`${API}/auth/forgot-password`, { email });
            toast.success("If an account exists with that email, a password reset link has been sent.");
            // We don't navigate immediately to give user time to read the toast
        } catch (error) {
            toast.error(error.response?.data?.detail || "Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-[#0a1a1f] via-[#005f6b] to-[#0a1a1f] flex items-center justify-center p-6">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="flex items-center justify-center gap-3 mb-4 cursor-pointer" onClick={() => navigate("/")}>
                        <img src={logoUrl} alt="Logo" className="w-14 h-14 rounded-full" />
                        <span className="text-2xl font-semibold text-[#d4af37]">BackOffice</span>
                    </div>
                    <h1 className="text-3xl font-bold text-[#f8f8f8] mb-2">Forgot Password</h1>
                    <p className="text-[#f8f8f8]/70">Enter your email to receive a reset link</p>
                </div>

                <div className="bg-[#0a1a1f]/80 backdrop-blur-sm rounded-2xl border border-[#d4af37]/20 p-8">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <Label htmlFor="email" className="text-[#f8f8f8]">Email</Label>
                            <Input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="you@business.com"
                                required
                                className="mt-2 bg-[#005f6b]/20 border-[#005f6b] text-[#f8f8f8] placeholder:text-[#f8f8f8]/40 focus:border-[#00ced1] focus:ring-[#00ced1]"
                            />
                        </div>

                        <Button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-[#00ced1] hover:bg-[#00ced1]/90 text-[#0a1a1f] font-semibold py-6 rounded-xl text-base"
                        >
                            {loading ? "Sending link..." : "Send Reset Link"}
                        </Button>
                    </form>

                    <div className="mt-6 text-center">
                        <Link to="/login" className="text-[#00ced1] hover:text-[#d4af37] font-medium flex items-center justify-center gap-2">
                            <ArrowLeft className="w-4 h-4" />
                            Back to Login
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
